import { Grid } from '@mantine/core';
import * as React from 'react';
import { Section } from '../../../../../react-commons/components/data-display/Section';
import { PersistableInfo } from '../../../resource/resource-base/persistableResourceTypes';
import { MetaDataInfoContent } from '../base/MetaDataInfoContent';
import { useUserActions } from '../../../resource/resources/persistables/user/userResource';

export const MetaDataDialogContent= ({ metaDataInfo, versionMetaDataInfo, close }: {
    metaDataInfo: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    };
    versionMetaDataInfo?: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    } | null;
    close: () => void;
}) => {
    const createdAtDate = new Date(metaDataInfo.persistableInfo.createdAt);
    const lastUpdatedAtDate = new Date(
        metaDataInfo.persistableInfo.lastUpdatedAt ?? metaDataInfo.persistableInfo.createdAt
    );

    const versionCreatedAtData = versionMetaDataInfo?.let((it) => new Date(it.persistableInfo.createdAt));
    const versionLastUpdatedAtData = versionMetaDataInfo?.let(
        (it) => new Date(it.persistableInfo.lastUpdatedAt ?? it.persistableInfo.createdAt)
    );

    const latestLastUpdatedAt = lastUpdatedAtDate;

    const userActions = useUserActions();

    const createdBy = userActions.useGetResource(metaDataInfo.persistableInfo.createdBy ?? undefined);
    const lastUpdatedBy = userActions.useGetResource(
        metaDataInfo.persistableInfo.lastUpdatedBy ?? undefined
    );
    const versionCreatedBy = userActions.useGetResource(versionMetaDataInfo?.persistableInfo.createdBy ?? undefined);
    const versionLastUpdatedBy = userActions.useGetResource(
        versionMetaDataInfo?.persistableInfo.lastUpdatedBy ?? undefined
    );

    return (
        <div style={{ minWidth: 1000, width: 1000 }}>
            <Grid>
                <Grid.Col span={12}>
                    <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                        <MetaDataInfoContent
                            metaDataInfo={metaDataInfo}
                            createdAt={createdAtDate}
                            createdBy={createdBy}
                            lastUpdatedAt={latestLastUpdatedAt}
                            lastUpdatedBy={lastUpdatedBy}
                        />
                    </div>
                </Grid.Col>
                {versionMetaDataInfo && (
                    <Grid.Col span={12}>
                        <Section label={'Version Metadata'} style={{ padding: 10 }}>
                            <MetaDataInfoContent
                                metaDataInfo={versionMetaDataInfo}
                                createdAt={versionCreatedAtData}
                                createdBy={versionCreatedBy}
                                lastUpdatedAt={versionLastUpdatedAtData}
                                lastUpdatedBy={versionLastUpdatedBy}
                            />
                        </Section>
                    </Grid.Col>
                )}
            </Grid>
        </div>
    );
};
